
import * as React from "react";
import avatar1 from '../assets/mk.png';
import avatar2 from '../assets/mk2.png';

import {
    Card,
    Button,
    Form,
    Comment,
} from "tabler-react";

interface HelloMessageProps {
}
export default class Intro extends React.Component<HelloMessageProps, {}>{
    render() {
        return (
            <Card>
                <Card.Header>
                    <Form.InputGroup>
                        <Form.Input type="text" placeholder="Message" />
                        <Form.InputGroup append>
                            <Button icon="camera" color="secondary" />
                        </Form.InputGroup>
                    </Form.InputGroup>
                </Card.Header>
                <Comment.List>
                    <Comment
                        avatarURL={avatar2}
                        date="10.12.2019"
                        name="Mahmut Keygubatli"
                        text={<React.Fragment><p>Habe nun mein <b>HourMgr</b> in ein Demo umgewandelt.
                                 Gerne könnt Ihr die <a href="hourmgr"><b>Browser App</b></a> testen.<br/>
                                 Die Daten werden in der Session-Store gespeichert. Dies bedeutet beim schließen des Browser Tabs,
                                  werden die Daten automatisch gelöscht.<br/>
                            HourMgr ist für die Arbeitszeiterfassung für Lieferservices, in Kooperation
                            mit <b>eat-prime.de</b>, erstellt worden.
                            Ziel war es eine moderne Single-Page-Webanwendung zu erstellen. </p>
                            <p>Eingesetzte Technologien: </p>
                            <p><b>TypeScript, ES6, React.js, Redux, Redux Saga, Rest, React Transition Group, Bootstrap 4, Express.js, Node.js, Mongo.db,
                                Jest, Puppeteer und viele andere Tools</b></p>
                            </React.Fragment>}
                        replies={null}
                    />
                    <Comment
                        avatarURL={avatar2}
                        date="21.05.2019"
                        name="Mahmut Keygubatli"
                        text={<p>Hallo und <b>"Herzlich Willkommen"</b> bei AreaWay, mein Motto:<br /><b>„Solution for Business“</b>.</p>}
                        replies={
                            <React.Fragment>
                                <Comment.Reply
                                    name="Mahmut Keygubatli"
                                    avatarURL={avatar1}
                                    text="Ich bin Consultant oder besser gesagt Freiberufler und arbeite hauptsächlich als Softwareentwickler."
                                />
                                <Comment.Reply
                                    name="Mahmut Keygubatli"
                                    avatarURL={avatar2}
                                    text="Was ich in meinem langjährigen Berufsleben als Programmierer alles erstellt und an Erfahrungen gesammelt habe, kannst Du hier auf meiner Homepage sehen. Ich werde Euch auch ein paar meiner Projekte zeigen."
                                />

                                <Comment.Reply
                                    name="Mahmut Keygubatli"
                                    avatarURL={avatar2}
                                    text="Solltes Du Interesse an einer gemeinsamen Zusammenarbeit haben, kannst Du mich Telefonisch oder über meine E-Mail Adresse kontaktieren."
                                />
                                <Comment.Reply
                                    name="Mahmut Keygubatli"
                                    avatarURL={avatar1}
                                    text="Ich wünsche Euch Viel Spaß beim Erkunden meiner Internetseite !!!"
                                />
                            </React.Fragment>
                        }
                    />
                </Comment.List>
            </Card>
        )
    }
}